import { render, staticRenderFns } from "./ProfileInvitedBy.vue?vue&type=template&id=74b2dbb4&scoped=true"
import script from "./ProfileInvitedBy.vue?vue&type=script&lang=ts&setup=true"
export * from "./ProfileInvitedBy.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ProfileInvitedBy.vue?vue&type=style&index=0&id=74b2dbb4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b2dbb4",
  null
  
)

export default component.exports